<template>
  <div class="col-md-12 mt-3">
    <div class="table-top d-flex justify-content-between align-items-center mb-3">
      <div class="d-flex justify-content-between align-items-center">
        <slot name="table_head"></slot>
        <div v-if="payload.filter" class="d-flex align-items-center">
          <div class="fw-bold fs-6 text-start fsize-10" v-if="payload.filterLabelDefault">
            {{payload.filterLabel}}
          </div>
          <div class="fw-bold fs-6 text-start fsize-10" v-else>
            <template v-if="payload.filterList">
              <Dropdown :options="payload.filterList" :value="filterSelected" :containerStyle="{width: '220px'}"
                @onChange="handleFilterSelected" />
            </template>
            <template v-else>
              <Dropdown :options="[filterLabelDisplay]" :value="filterLabelDisplay" :isStatic="true"/>
            </template>
          </div>
          <template v-if="!this.payload?.hideFilterDate">
            <div class="d-flex align-items-center">
              <span class="px-3"> From: </span>
              <DatePicker v-model="from" :auto-apply="datepickerOption?.autoApply"
                :enable-time-picker="datepickerOption?.timePicker" placeholder="Start Date" :format="'MM/dd/yyyy'"
                textInput />
            </div>
            <div class="d-flex align-items-center">
              <span class="px-3"> To: </span>
              <DatePicker v-model="to" :auto-apply="datepickerOption?.autoApply"
                :enable-time-picker="datepickerOption?.timePicker" :format="'MM/dd/yyyy'" placeholder="End Date"
                textInput />
            </div>
            <button class="btn ms-3 border rounded" style="background-color: #ffffff; width: 100px; height: 30px"
              @click="resetFilter">
              Reset Filter
            </button>
          </template>
        </div>
        <div v-if="payload.filter_custom" class="d-flex align-items-center">
          <div v-if="payload.filterList.length > 1" class="d-flex fs-6 text-start fsize-10">
            <Dropdown :options="payload.filterList" :value="filterSelected" :containerStyle="{width: '200px'}"
              @onChange="handleFilterSelected" />

            <div v-if="filterSelected.key == 'price_regular' || filterSelected.key == 'price_sale'" class="d-flex">
              <label class="ms-3 mt-2">Min</label>
              <input v-model="filterValue" class="form-control ms-2" style="width: 150px;" type="number" />
              <label class="ms-3 mt-2">Max</label>
              <input v-model="filterValueSecond" class="form-control ms-2" style="width: 150px;" type="number" />
            </div>
            <div v-if="filterSelected.key == 'category_product_id'" class="d-flex">
              <SlotDropdown containerClass="ms-3" :value="filterValue" :options="filterOptions"
                placeholder="Select Category" @onChange="(val)=>filterValue=val.value"
                @onInputChange="(val)=>handleDropdownLazy({type:'category_parent', value: val})" :isInput="true" />
              <SlotDropdown containerClass="ms-3" :value="filterValueSecond" :options="filterOptionsSecond"
                placeholder="Select Sub Category" @onChange="(val)=>filterValueSecond=val.value"
                @onInputChange="(val)=>handleDropdownLazy({type:'category_child', value: val})" :isInput="true"
                :disabled="!filterValue" />
            </div>
            <div v-if="filterSelected.key == 'category_promo_id'" class="d-flex">
              <SlotDropdown containerClass="ms-3" :value="filterValue" :options="filterOptions"
                placeholder="Select Promo" @onChange="(val)=>filterValue=val.value"
                @onInputChange="(val)=>handleDropdownLazy({type:'category_promo', value: val})" :isInput="true" />
            </div>
            <div v-if="filterSelected.key == 'seller_name'" class="d-flex">
              <input v-model="filterValue" class="form-control ms-3" style="width: 150px;" type="text" />
            </div>
          </div>
          <div v-if="!payload.hide_reset_filter">
            <button class="btn ms-3 border rounded" style="background-color: #ffffff; width: 100px; height: 30px"
              @click="resetFilter">
              Reset Filter
            </button>
          </div>
        </div>
        <div v-if="showExport" class="ms-3">
          <button :class="['btn btn-danger', payload?.exportOptions?.disabled ? 'disabled' : '']"
            @click="exportClick()">
            <font-awesome-icon class="text-white" icon="fa-solid fa-upload" />
            <strong class="text-white ms-2">Export</strong>
          </button>
        </div>
      </div>

      <div style="flex:1;">
        <div class="d-flex justify-content-end">
          <div v-if="payload.search" class="input-group ms-3" :style="[{maxWidth: '210px'}, payload.searchContainerStyle]">
            <input 
              type="text" 
              v-model="search" 
              :placeholder="payload.searchPlaceholder" 
              :disabled="payload.searchDisabled"
              @keyup.enter="handleEnterSearch"
              aria-describedby="basic-addon2"
              aria-label="Search By" 
              class="form-control" 
              style="border-right: 0px !important;" 
              />
            <button 
              id="basic-addon2" 
              class="input-group-text"
              style="background-color: white; border-left: 0px !important"
              :disabled="payload.searchDisabled"
              @click="change"
            >
              <img alt="" src="@/assets/form/ic-search.svg"/>
            </button>
          </div>
          <button v-if="payload.button_name" class="btn btn-danger text-white"
            style="min-width: 135px; height: max-content; margin-left: 25px"
            :disabled="payload.addDisabled"
            @click="this.$router.push(`${payload.button_link}`)">
            <img v-if="payload.icon_button == 'add'" alt="" src="@/assets/form/ic_add_detail.svg" />
            {{ payload.button_name }}
            
          </button>
        </div>
      </div>
    </div>
    <div v-if="payload.totalItems > 0" class="d-flex justify-content-start mb-3">
      <button class="btn me-2 rounded border" style="background-color: #ffffff" @click="deselectAll">
        Deselect All
      </button>
      <button class="btn rounded border" style="background-color: #ffffff" @click="deleteItems"
        v-if="payload.deleteProductRow">
        Delete {{ payload.totalItems }} Products
      </button>
      <button v-for="button in payload.buttonRow" :key="button" class="btn me-2 rounded border"
        style="background-color: #ffffff" @click="changeStatus(button.status)">
        {{ button.label }}
      </button>
    </div>
    <div v-show="showAlert" class="alert alert-warning" role="alert">
      {{ showMessage }}
    </div>
    <slot name="header"></slot>
    <div class='table-wrapper' :style="[payload.wrapperStyle]">
      <div 
        v-if="loadingTable" 
        class="d-flex align-items-center justify-content-center p-3"
      >
        <div
          class="spinner-border text-danger"
          role="status"
          style="width: 3rem; height: 3rem; border-width: 0.5rem"
        >
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <table v-else class="table bg-white" :style="{border: '#e6eaf5 !important', width: 'max-content', minWidth: '100%'}">
        <thead>
          <tr>
            <td v-if="payload.checkbox" class="checkbox-td">
              <input 
                class="form-check-input mt-0" 
                type="checkbox" 
                value="" 
                :checked="payload?.value?.length && payload.value.length === pickItems.length"
                @click="clickAllCheckbox($event, checkboxKeyId)" 
                />
            </td>
            <th v-for="(data,index) in payload.header" :key="data" :class="[data.class, data?.headerClass || '']" scope="col" :style="[data.style, data?.headerStyle || '']"
              style="color: #8d94a6">
              <span>
                {{ data.label }}
              </span>
                <span v-if="data.sort" class="icon-header" @click="sortData(index,data.sort_key)" :style="data.sort_style">
                  <font-awesome-icon v-if="sortType[index] == -1" class="arrow-down text-warning"
                    icon="fa-solid fa-sort-down" />
                  <font-awesome-icon v-else class="arrow-up text-warning" icon="fa-solid fa-sort-up" />
                </span>
            </th>
          </tr>
        </thead>
        <td v-if="$slots['empty_table'] && !payload.value?.length" colspan="100%">
          <slot name="empty_table"></slot>
        </td>
        <tbody 
          :key="data" 
          v-for="(data, index) in payload.value" 
          :style="[
            `border-top:transparent`,
            `${
              data.is_disabled
                ? 'background-color:#E3E3E3'
                : data.is_active
                ? 'background-color:#F3F2F8'
                : ''
            }`,
          ]"
          >
          <tr>
            <td v-if="payload.checkbox" class="checkbox-td">
              <input :checked="pickItems?.includes(data[checkboxKeyId])" class="form-check-input" type="checkbox"
                @click="clickCheckBox(index, $event, checkboxKeyId)" />
            </td>
            <td v-for="compare in payload.header" :key="compare" :class="[compare.class, 'align-middle', compare.columnClass || '']" :style="[compare.style, compare.columnStyle || '']">
              <div v-if="compare.link">
                <router-link
                  v-if="compare.param"
                  :to="compare.link + '/' + data[compare.key] + compare.param"
                  class="text-decoration-none fw-bold"
                >
                  {{ data[compare.key] }}
                </router-link>
                <router-link
                  v-else
                  :to="compare.link + '/' + data[compare.key]"
                  class="text-decoration-none fw-bold"
                >
                  {{ data[compare.key] }}
                </router-link>
              </div>
              <div v-else>
                <slot v-if="$slots[compare.key]" :data="data" :items="payload" :name="compare.key"
                  :value="data[compare.key]" :index="index"></slot>
                <div v-else-if="compare.isCurrency && data[compare.key]">
                  {{filters.rupiah(data[compare.key])}}
                </div>
                <div v-else>
                  {{ data[compare.key] }}
                </div>
              </div>
            </td>
          </tr>
          <template v-if="data.additional_row">
            <tr v-if="!data.additional_data" style="background-color: #f9f9fc">
              <td v-if="payload.checkbox">
                <!-- empty space -->
              </td>
              <td v-for="compareScnd in payload.second_header" :key="compareScnd" :class="[compareScnd.class]">
                <div v-if="compareScnd.link">
                  <router-link
                    :to="compareScnd.link + '/' + data[compareScnd.key]"
                    class="text-decoration-none"
                    style="color: #5e50a1"
                  >
                    {{ data[compareScnd.key] }}
                  </router-link>
                </div>
                <div v-else>
                  <slot v-if="$slots[compareScnd.key]" :data="data" :items="payload" :name="compareScnd.key"
                    :value="data[compareScnd.key]"></slot>
                  <div v-else>
                    {{ data[compareScnd.key] }}
                  </div>
                </div>
              </td>
            </tr>
            <tr v-for="val in data.additional_data" v-else :key="val" class="text-start"
              style="background-color: #f9f9fc">
              <td v-if="payload.checkbox">
                <!-- empty space -->
              </td>
              <td v-for="compareScnd in payload.second_header" :key="compareScnd" :class="compareScnd.class">
                <div v-if="compareScnd.link">
                  <router-link
                    :to="compareScnd.link + '/' + val[compareScnd.key]"
                    class="text-decoration-none"
                    style="color: #5e50a1"
                  >
                    {{ val[compareScnd.key] }}
                  </router-link>
                </div>
                <div v-else>
                  <slot v-if="$slots[compareScnd.key]" :data="val" :items="payload" :name="compareScnd.key"
                    :value="val[compareScnd.key]"></slot>
                  <div v-else>
                    {{ val[compareScnd.key] }}
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </table>
    </div>
    <div v-if="payload.value?.length" class="row">
      <div class="d-flex justify-content-between align-items-baseline">
        <div v-if="payload.perPage" class="d-flex align-items-center">
          <div>Show &nbsp;</div>
          <div class="page-option">
            <select v-model="perPage" aria-label="Default select example" class="form-select" @change="changeRow">
              <option v-for="data in payload.pageOptions" :key="data" :value="data">
                {{ data }} Entries
              </option>
            </select>
          </div>
          <div>&nbsp;Per Page</div>
        </div>
        <nav v-if="payload.currentPage" aria-label="Page navigation example ">
          <ul class="pagination">
            <li :class="isInFirstPage ? 'disabled' : ''" class="page-item">
              <span tabindex="0" class="page-link" @click="changePage(fromPage - 1)">
                <i class="fas fa-angle-left"></i>
              </span>
            </li>
            <li v-for="item in onlyShow.slice(0, 1)" :key="item" class="page-item disabled">
              <span v-if="item > 1" class="page-link">...</span>
            </li>
            <li v-for="index in onlyShow" :key="index" :class="payload.currentPage === index ? 'active' : ''"
              class="page-item">
              <span tabindex="0" class="page-link" @click="changePage(index)">{{ index }}</span>
            </li>
            <li v-if="onlyShow[onlyShow.length - 1] != totalPage" class="page-item disabled">
              <span class="page-link">...</span>
            </li>
            <li :class="isInLastPage ? 'disabled' : ''" class="page-item">
              <span tabindex="0" class="page-link" @click="changePage(fromPage + 1)">
                <i class="fas fa-angle-right"></i>
              </span>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</template>
<script>
  import DatePicker from "@vuepic/vue-datepicker";
  import "@vuepic/vue-datepicker/dist/main.css";
  import Dropdown from "@/components/Dropdown.vue";
  import SlotDropdown from "@/components/SlotDropdown.vue";
  import moment from "moment";
  import lodash from "lodash"

  export default {
    components: {
      DatePicker,
      Dropdown,
      SlotDropdown
    },
    props: {
      payload: {
        type: Object,
        default: () => ({
          value: Object,
          header: Object,
          pageOptions: Array,
          pickItems: Array,
          perPage: Number,
          totalRows: Number,
          currentPage: Number,
          totalItems: Number,
          listFilterValue: Array,
          datepickerOption: Object,
          listFilterValueSecond: Array,
          searchInput: String,
        }),
      },
      pageChangeScrollUp: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {
        totalItems: this.payload.totalItems ? this.payload.totalItems : 0,
        showAlert: false,
        showMessage: "",
        checkboxKeyId: this.payload.checkboxKeyId || "id",
        pickItems:  this.payload?.pickItems || [],
        search: this.payload.searchInput ? this.payload.searchInput : "",
        sortType: [],
        sortBy: "created_at",
        fromPage: this.payload.currentPage,
        perPage: this.payload.perPage,
        datepickerOption: this.payload.datepickerOption,
        from: "",
        to: "",
        settingPage: {},
        // for filter and filter_custom
        filterSelected: this.payload.filterList ? this.payload.filterList[0] : {},
        // for filter_custom
        filterValue: "",
        filterValueSecond: ""
      };
    },
    computed: {
       loadingTable(){
        return this.$store.state.loadingTable
      },
      // PARSING FILTERLABEL FOR DISPLAY ONLY
      filterLabelDisplay(){
          return {
            label: this.payload.filterLabel,
            value: this.payload.filterLabel
          }
      },
      // PARSING FILTER OPTIONS
      filterOptions() {
        if (!this.payload?.listFilterValue?.length) return []
        return this.payload?.listFilterValue?.map(val => {
          return {
            label: val.name,
            value: val.id
          }
        })
      },
      filterOptionsSecond() {
        if (!this.payload?.listFilterValueSecond?.length) return []
        return this.payload?.listFilterValueSecond?.map(val => {
          return {
            label: val.name,
            value: val.id
          }
        })
      },
      showExport() {
        if (this.payload?.exportOptions?.hidden) return false
        if (!this.payload?.export) return false
        return true
      },
      labelPage() {
        var from = "";
        var to = "";
        var sum = 0;
        for (let i = 1; i <= this.payload.currentPage; i++) {
          sum = i * this.payload.perPage;
          if (this.payload.totalRows <= sum) {
            from = sum - this.payload.perPage + 1;
            to = this.payload.totalRows - sum + sum;
          } else {
            from = sum - this.payload.perPage + 1;
            to = sum;
          }
        }
        const payload = {
          from,
          to,
        };
        return payload;
      },
      totalPage() {
        const data = Math.ceil(this.payload.totalRows / this.payload.perPage);

        return data;
      },
      onlyShow() {
        var data = [];
        var page = this.payload.currentPage;
        var start = Math.max(0, page - 2);
        var end = Math.min(start + 3, this.payload.totalRows);
        for (var i = start; i < end; i++) {
          if (this.totalPage > i) {
            data.push(i + 1);
          }
        }
        return data;
      },
      isInFirstPage() {
        return this.payload.currentPage === 1;
      },
      isInLastPage() {
        return this.payload.currentPage === this.totalPage;
      },

    },
    watch: {
      payload: {
        handler: function (value) {
          this.fromPage = value.currentPage
          this.perPage = value.perPage
          if(value.pickItems && !value.pickItems?.length){
            this.pickItems = value.pickItems
          }
        },
        deep: true,
      },
      from() {
        this.filterDate()
      },
      to() {
        this.filterDate()
      },
      filterSelected() {
        this.settingPage.filter = this.filterSelected
        // reset value if dropdown filter changed
        this.filterValue = ""
        this.filterValueSecond = ""
        this.change()
      },
      filterValue(val) {
        this.settingPage.filter = this.filterSelected;
        let obj = {
          filter_value: val
        }
        // handle only for category product dropdown
        // reset filtervaluesecond on change of filtervalue
        if (this.filterSelected.key == "category_product_id") {
          this.filterValueSecond = ""
        }
        if (this.filterSelected.key != "category_product_id") {
          obj.filter_value_second = this.filterValueSecond
        }
        // make sure filter sort start at page 1
        this.resetPage()
        this.change(obj);

      },
      filterValueSecond(val) {
        this.settingPage.filter = this.filterSelected
        // make sure filter sort start at page 1
        this.resetPage()
        this.change({
          filter_value: this.filterValue,
          filter_value_second: val
        })
      },
      search: lodash.debounce(function(value) {
        // only run if search is empty
        if(!value){
          this.resetPage()
          this.change()
        }
      }, 1000)
    },
    methods: {
      resetPage() {
        this.fromPage = 1
      },
      handleEnterSearch() {
        if(this.search){
          this.resetPage()
          this.change()
        }
      },
      handleDropdownLazy({
        type,
        value
      }) {
        this.$emit("onLazyDropdown", {
          type,
          value
        })
      },
      deselectAll() {
        this.pickItems = [];
        this.settingPage.pick_items = [];
        this.settingPage.filter = {}
        this.totalItems = 0
        this.change()
      },
      clickAllCheckbox(event, keyValue) {
        for (let index = 0; index < this.payload?.value?.length; index++) {
          if (event.target.checked) {
            this.pickItem(index, keyValue)
          }
        }
        if (!event.target.checked) {
          this.pickItems = [];
        }

        this.settingPage.pick_items = this.pickItems
        this.settingPage.filter = {}
        this.totalItems = this.pickItems.length
        this.change()
      },
      clickCheckBox(index, event, keyValue) {
        if (event.target.checked) {
          this.pickItem(index, keyValue)
        } else {
          this.unpickItem(index, keyValue)
        }
        this.settingPage.pick_items = this.pickItems
        this.totalItems = this.pickItems.length
        this.settingPage.filter = {}
        this.change()
      },
      pickItem(index, keyValue) {
        const found = this.pickItems.find((x) => {
          return x === this.payload.value[index][keyValue];
        });

        if (!found) {
          this.pickItems.push(this.payload.value[index][keyValue]);
        }
      },
      unpickItem(index, keyValue) {
        this.pickItems = this.pickItems.filter(x => {
          return x !== this.payload.value[index][keyValue]
        })
      },
      changeRow() {
        this.resetPage()
        this.change()
      },
      changePage(index) {
        this.fromPage = index
        // reset selected
        this.pickItems = [];
        this.settingPage.pick_items = []
        // scroll to up
        if (this.pageChangeScrollUp) {
          window.scrollTo(0, 0);
        }
        // ============
        this.change()
      },
      sortData(index, key) {
        this.sortType[index] = this.sortType[index] == 1 ? -1 : 1
        this.sortBy = key
        this.settingPage.sort_by = this.sortBy
        this.settingPage.sort_type = this.sortType[index]
        // make sure filter sort start at page 1
        this.resetPage()
        // scroll to up
        if (this.pageChangeScrollUp) {
          window.scrollTo(0, 0);
        }
        // ============
        this.change()
      },
      deleteItems() {
        this.change({
          delete_items: true
        })
      },
      changeStatus(status) {
        this.change({
          status
        })
      },
      resetFilter() {
        this.from = ""
        this.to = ""
        this.filterValue = ""
        this.filterValueSecond = ""
        // this.settingPage.filter = {
        //     "from": this.from != "" ? moment(this.from).format("YYYY-MM-DD") : "",
        //     "to": this.to != "" ? moment(this.to).format("YYYY-MM-DD") : "",
        //   }
        // this.change()
      },
      filterDate() {
        if (moment(this.from).isAfter(this.to)) {
          this.showAlert = true
          this.showMessage = "From date should not be greater than To date"
          this.to = ""
          setTimeout(() => {
            this.showAlert = false
          }, 3000);

        } else {
          this.settingPage.filter = {
            "from": this.from ? moment(this.from).format("YYYY-MM-DD") : "",
            "to": this.to ? moment(this.to).format("YYYY-MM-DD") : "",
          }

          this.resetPage()
          this.change()
        }
      },
      change(data) {
        let payload = {
          // prevent pick_items to be undefined on some pages
          pick_items: [],
          ...this.settingPage
        }
        payload.current_page = this.fromPage
        payload.search = this.search
        payload.per_page = this.perPage
        if (data) {
          // used example for changeStatus and deleteItems,
          // that function have a param of object
          Object.keys(data).forEach(key => {
            if (data[key]) payload[key] = data[key]
          })
        }
        // make sure filterValue or filterValueSecond if have a value, add it to payload
        if(this.filterValue) payload.filter_value = this.filterValue
        if(this.filterValueSecond) payload.filter_value_second = this.filterValueSecond
        this.$emit("onChange", payload);
      },
      exportClick() {
        this.$emit("onExport", this.settingPage);
      },
      handleFilterSelected(value) {
        this.filterSelected = value
      }
    },

  };
</script>
<style scoped>
  .icon-header {
    display: inline;
    margin-left: 20px;
    cursor: pointer;
  }

  .table-wrapper {
    overflow-x: auto;
    overflow-y: hidden;
  }

  .arrow-up {
    position: relative;
    top: 3px;
  }

  .arrow-down {
    position: relative;
    bottom: 3px;
  }

  .checkbox-td {
    vertical-align: middle;
    width: 1%;
  }

  .page-link {
    color: #cccccd !important;
    border: 0px !important;
    cursor: pointer;
  }

  .pagination {
    border-radius: 4px;
    background-color: white !important;
    padding: 6px 8px !important;
    border: 1px solid #e6eaf5;
  }

  .page-item.active .page-link {
    background-color: #ff434f !important;
    border-color: #ff434f !important;
    color: #fff !important;
    border-radius: 4px;
  }

  .page-link:hover {
    background-color: #ff434f !important;
    border-color: #ff434f !important;
    color: #fff !important;
    border-radius: 4px;
  }

  .page-link:focus {
    box-shadow: 0 0 0 0.25rem rgba(94, 80, 161, 0.25);
  }
</style>